import { Suspense, useEffect } from "react";
import { Outlet, useLocation } from "react-router-dom";
import Header from "../Header/Header";
import Footer from "../Footer/Footer";
import AnimatedCursor from "../AnimatedCursor/AnimatedCursor";

const ScrollToTop = () => {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: "instant" });
  }, [pathname]);
  return null;
};

const Layout = () => (
  <>
    <a href="#main" className="skip-link">
      Skip to content
    </a>
    <ScrollToTop />
    <AnimatedCursor />
    <Header />
    <main id="main" tabIndex={-1}>
      <Suspense fallback={<div className="page-loading" aria-busy="true" />}>
        <Outlet />
      </Suspense>
    </main>
    <Footer />
  </>
);

export default Layout;
